export enum FontWeight {
  REGULAR = 400,
  MEDIUM = 500,
  BOLD = 700,
  BOLDER = 900
}

export const EBreakpoints = {
  MOBILE1: "mobile-1",
  MOBILE2: "mobile-2",
  TABLET1: "tablet-1"
};
